import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GetSupplierTaskStepsStateSuccess, Get_Task_Step_State } from '../actions/supplier-task.action';
import { withLatestFrom, map, filter, exhaustMap, switchMap, catchError } from 'rxjs/operators';
import { IncrementLoaderCount, DecrementLoaderCount } from 'app/shared/store/actions/loader.actions';
import { PushError } from 'app/shared/store/actions/error.actions';
import { SelectSupplierTaskStepByType } from '../selectors/supplier-tasks.selector';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { SupplierTasksState } from '../state/supplier-tasks.state';
import { GetTaskStepState } from '../app.actions';

@Injectable()
export class SupplierTaskEffects {
    constructor(
        private actions$: Actions,
        private store: Store<SupplierTasksState>,
        private supplierTaskService : SupplierTaskService) { }

    @Effect()
    getSupplierTaskStep$ = this.actions$
        .pipe(
            ofType(Get_Task_Step_State),
            map((action: GetTaskStepState) => action),
            withLatestFrom(this.store.select(SelectSupplierTaskStepByType)),
            filter(([action, state]) => action.forceReload || state == null),
            exhaustMap(([action]) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.supplierTaskService.getSupplierTaskStep(action.supplierCode, action.taskId, action.taskType)
                    .pipe(
                        switchMap((taskInfo) => {
                            return [
                                new GetSupplierTaskStepsStateSuccess(taskInfo),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError((err) => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );
}
